import { render, staticRenderFns } from "./UserIdInput.vue?vue&type=template&id=770799fe&lang=pug"
import script from "./UserIdInput.vue?vue&type=script&lang=ts"
export * from "./UserIdInput.vue?vue&type=script&lang=ts"
import style0 from "./UserIdInput.vue?vue&type=style&index=0&id=770799fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VChip,VCombobox})
